import dayjs, { Dayjs } from 'dayjs';
import primaryStationIcon from './assets/level-primary-station.png';
import secondaryStationIcon from './assets/level-secondary-station.png';
import tertiaryStationIcon from './assets/level-tertiary-station.png';
import outgoingLineIcon from './assets/level-outgoing-line.png';
import type { AnalysisGroup, Dimension, LoadRangeKey, PeriodMode, PeriodRange } from './types';

const DIMENSION_META: Record<Dimension, { name: string; description: string; icon: string }> = {
  plant: { name: '一级站房(全厂)', description: '全厂汇总', icon: primaryStationIcon },
  station: { name: '配电站', description: '二级配电站', icon: secondaryStationIcon },
  area: { name: '变电站', description: '三级变电站', icon: tertiaryStationIcon },
  line: { name: '出线', description: '出线开关', icon: outgoingLineIcon },
  outlet: { name: '供气出口', description: '出口管线', icon: outgoingLineIcon },
  compressor: { name: '压缩机', description: '压缩机设备', icon: tertiaryStationIcon },
};

export const resolveDimensionMeta = (dimension: Dimension, mediumType: number) => {
  if (mediumType !== 0) {
    const gasMeta: Partial<Record<Dimension, { name: string; description: string; icon: string }>> = {
      plant: { ...DIMENSION_META.plant, name: '全厂', description: '全厂气源' },
      station: { ...DIMENSION_META.station, name: '站房', description: '燃气站' },
      outlet: { ...DIMENSION_META.outlet, name: '出口', description: '出口总管' },
      area: { ...DIMENSION_META.area, name: '区域', description: '区域分管' },
    };
    return gasMeta[dimension] ?? DIMENSION_META[dimension];
  }
  return DIMENSION_META[dimension];
};

export const getPeriodRange = (mode: PeriodMode, date: Dayjs): PeriodRange => {
  if (mode === 'day') {
    const target = dayjs().startOf('day');
    return { startTime: target.valueOf(), endTime: target.endOf('day').valueOf() };
  }
  return {
    startTime: date.startOf(mode).valueOf(),
    endTime: date.endOf(mode).valueOf(),
  };
};

export const getRange = (row: AnalysisGroup['rows'][number], key: LoadRangeKey) => {
  const ranges = row.rangeDurations ?? [];
  if (key === 'high') {
    const high = ranges.filter(item => item.range === 'high' || item.range === 'over');
    if (!high.length) return undefined;
    return {
      duration: high.reduce((total, item) => total + Number(item.duration ?? 0), 0),
      durationPercent: high.reduce((total, item) => total + Number(item.durationPercent ?? 0), 0),
    };
  }
  return ranges.find(item => item.range === key);
};

export const formatHours = (minutes?: number) => {
  if (minutes === undefined || minutes === null) return '--';
  return `${(Number(minutes) / 60).toFixed(1)}`;
};

export const formatPercent = (value?: number) => {
  if (value === undefined || value === null) return '--';
  const percent = Math.abs(value) <= 1 ? value * 100 : value;
  return `${percent.toFixed(1)}%`;
};
